import PortalIdParser from 'PortalIdParser';
import { useCallback, useMemo, useRef } from 'react';
import { getFullUrl } from 'hubspot-url-utils';

// @ts-expect-error Untyped dependency
import UIModalIFrame from 'ui-addon-iframeable/host/UIModalIFrame';
import { jsx as _jsx } from "react/jsx-runtime";
function PropertyManagementModalIFrame({
  open,
  onResult,
  onClose,
  onError,
  mode,
  createParams,
  cloneParams,
  editParams,
  inlineParams,
  displayConfig
}) {
  const hostContextRef = useRef(undefined);
  const src = useMemo(() => `${getFullUrl('app')}/property-management-ui/${PortalIdParser.get()}`, []);
  const embeddedPassthruProps = useMemo(() => ({
    passthruProps: {
      open,
      mode,
      createParams,
      cloneParams,
      editParams,
      inlineParams,
      displayConfig
    }
  }), [cloneParams, createParams, displayConfig, editParams, inlineParams, mode, open]);
  const handleIFrameError = useCallback(() => {
    onResult({
      cancelled: true
    });
  }, [onResult]);
  const shouldShowFullScreen = useMemo(() => mode === 'CLONE' || mode === 'EDIT' || mode === 'CREATE', [mode]);
  const handleIFrameMessage = useCallback(({
    payload
  }) => {
    switch (payload.type) {
      case 'error':
        onError === null || onError === void 0 || onError(payload.reason);
        break;
      case 'cancelled':
        onResult({
          cancelled: true
        });
        break;
      case 'create/success':
        onResult({
          type: 'create',
          cancelled: false,
          createdPropertyDefinition: payload.createdPropertyDefinition,
          additionalData: payload.additionalData
        });
        break;
      case 'save/success':
        onResult({
          type: 'save',
          cancelled: false,
          savedPropertyDefinition: payload.savedPropertyDefinition,
          additionalData: payload.additionalData
        });
        break;
      default:
        break;
    }
  }, [onError, onResult]);
  return /*#__PURE__*/_jsx(UIModalIFrame, Object.assign({
    appName: "property-management-ui",
    name: "property-management-iframe",
    show: open,
    preload: true,
    showLoadingIndicator: true,
    src: src
  }, shouldShowFullScreen ? {
    use: 'fullscreen',
    width: '100%'
  } : {
    use: 'sidebar',
    width: 600
  }, {
    height: "100%",
    embeddedPassthruProps: embeddedPassthruProps,
    iframePassthruProps: {
      'data-test-id': 'property-management-iframe'
    },
    onReady: hostContext => {
      hostContextRef.current = hostContext;
    },
    onMessage: handleIFrameMessage,
    onClose: () => {
      onClose();
    },
    onInitError: handleIFrameError,
    onReadyError: handleIFrameError
  }));
}
export default PropertyManagementModalIFrame;